import BootstrapTable from "react-bootstrap-table-next";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import paginationFactory, {
  PaginationProvider,
} from "react-bootstrap-table2-paginator";

const customTotal = (from, to, size) => (
  <span className="react-bootstrap-table-pagination-total">
    Showing {from} to {to} of {size}
  </span>
);

const NoDataIndication = () => (
  <div className="spinner">
    <div className="rect1" />
    <div className="rect2" />
    <div className="rect3" />
    <div className="rect4" />
    <div className="rect5" />
  </div>
);

const emptyDataMessage = () => {
  return "No Data Found";
};

const makeSortCaret = (dataField, sortField, sortOrder) => () => {
  const active = sortField && dataField === sortField;
  if (!active) return <span style={{ marginLeft: 4, opacity: 0.4 }} title="Click to sort">⇅</span>;
  if (sortOrder === "asc") return <span style={{ marginLeft: 4 }} title="Sorted ascending — click to sort descending">↑</span>;
  return <span style={{ marginLeft: 4 }} title="Sorted descending — click to sort ascending">↓</span>;
};

const RemotePagination = ({
  data,
  columns,
  page,
  sizePerPage,
  onTableChange,
  totalSize,
  rowClasses,
  selectRow,
  keyField,
  sortField,
  sortOrder,
}) => {
  const enhancedColumns = columns.map(col =>
    col.sort
      ? { ...col, sortCaret: makeSortCaret(col.dataField, sortField, sortOrder) }
      : col
  );
  return <div>
    <PaginationProvider
      pagination={paginationFactory({
        // custom: true,
        page,
        sizePerPage,
        totalSize,
        alwaysShowAllBtns: true, // Always show next and previous button
        withFirstAndLast: true, // Hide the going to First and Last page button
        hideSizePerPage: true, // Hide the sizePerPage dropdown always
        hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
        firstPageText: false,
        prePageText: false,
        nextPageText: false,
        lastPageText: false,
        nextPageTitle: "Next page",
        prePageTitle: "Pre page",
        firstPageTitle: "First page",
        lastPageTitle: "Last page",
        showTotal: true,
        paginationTotalRenderer: customTotal,
        disablePageTitle: false,
      })}
    >
      {({ paginationTableProps }) => (
        <div className="table-record-data tabel-application">
          {data?.length > 0 ? (
            <BootstrapTable
              remote
              keyField={keyField}
              id="uios"
              data={data}
              columns={enhancedColumns}
              onTableChange={onTableChange}
              noDataIndication={() => <NoDataIndication />}
              rowClasses={rowClasses}
              selectRow={selectRow}
              {...paginationTableProps}
            />
          ) : (
            <BootstrapTable
              remote
              keyField={keyField}
              data={[]}
              id="uios"
              columns={enhancedColumns}
              onTableChange={onTableChange}
              noDataIndication={emptyDataMessage}
              rowClasses={rowClasses}
              {...paginationTableProps}
              selectRow={selectRow}
            />
          )}
        </div>
      )}
    </PaginationProvider>
  </div>
};

export default RemotePagination;
